<!--
 * @Author: your name
 * @Date: 2021-10-29 14:53:28
 * @LastEditTime: 2021-11-01 16:45:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dsicm-admin-web\src\views\decisionPage\leftModule\components\Collapse.vue
-->
<template>
  <div class="collapse">
    <!-- 大标题 -->
    <div v-for="(item, key, index) in logicList" :key="index">
      <div :class="`message-item-box-title${openFlag[key] ? ' active' : ''}`" @click="open(key)">
        <span class="message-item-box-name">{{ key }}</span>
        <div class="message-item-box-text">
          <span class="name-icon">{{ openFlag[key] ? "收起" : "展开" }}</span>
          <span class="instructions_icon" :class="!openFlag[key] ? 'down_icon' : 'up_icon'"></span>
        </div>
      </div>
      <div class="p_cont" :ref="`liCon${key}`">
        <div v-for="(items, keys) in item" :key="keys" class="p_cont_list" @click="logicClick(items.id)">
          <div class="text">{{ items.decisionTreeName }}</div>
          <span>{{ items.executedTime }}</span>
        </div>
      </div>
    </div>

    <!-- 逻辑生效弹框 -->
    <el-dialog title="逻辑生效" :visible.sync="logicVisible" center @open="openDialog" @close="closeDialog" :modal="modal">
      <div class="content">
        <div class="left-content">
          <el-tabs v-model="resultName">
            <el-tab-pane v-for="(item, key) in logicData.leftData" :key="key" :label="`结果${key + 1}`"
              :name="`结果${key + 1}`">
              <el-scrollbar style="height: 510px">
                <div v-for="(items, keys) in item" :key="keys">
                  <!-- 编链 nodeType === 2 && outputType === 4 -->
                  <div v-if="items.nodeType === 2 && items.outputType === 4">
                    <div class="header" style="margin-bottom: 0">
                      <p></p>
                      <h1>编链</h1>
                    </div>
                    <div class="data-content">
                      <div class="chaining">
                        <span class="label">编链类型：</span>
                        <span class="value">{{ translateItemType(JSON.parse(items.outputContent).itemType) }}</span>
                      </div>
                      <div class="chaining">
                        <span class="label">开始时间类型：</span>
                        <span class="value">{{ translateStartTimeType(JSON.parse(items.outputContent).startTimeType) }}
                          {{ JSON.parse(items.outputContent).startIntervalTime }}{{ JSON.parse(items.outputContent).startIntervalType }}</span>
                      </div>
                      <div class="chaining">
                        <span class="label">名称：</span>
                        <span
                          class="value">{{ JSON.parse(items.outputContent).itemType === 2 || JSON.parse(items.outputContent).itemType === 9 ?  `${JSON.parse(items.outputContent).courseName} ${JSON.parse(items.outputContent).itemName}` : JSON.parse(items.outputContent).itemName }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- 文本 -->
                  <div v-if="items.nodeType === 2 && items.outputType === 1">
                    <div class="header" style="margin-bottom: 0">
                      <p></p>
                      <h1>文本</h1>
                    </div>
                    <div class="data-content">
                      <div class="text">{{ items.displayContent }}</div>
                    </div>
                  </div>
                  <!-- 问卷/宣教 -->
                  <div v-if="items.nodeType === 2 && items.outputType === 2">
                    <div class="header" style="margin-bottom: 0">
                      <p></p>
                      <h1>问卷</h1>
                    </div>
                    <div class="data-content">
                      <div class="ques">{{ items.displayContent }}</div>
                    </div>
                  </div>
                  <div v-if="items.nodeType === 2 && items.outputType === 3">
                    <div class="header" style="margin-bottom: 0">
                      <p></p>
                      <h1>宣教</h1>
                    </div>
                    <div class="data-content">
                      <div class="ques">{{ items.displayContent }}</div>
                    </div>
                  </div>
                  <!-- 通知 -->
                  <div v-if="items.nodeType === 4">
                    <div class="header" style="margin-bottom: 0">
                      <p></p>
                      <h1>通知</h1>
                    </div>
                    <div class="data-content">
                      <div class="notify">
                        <div class="notify-title">
                          <span>通知人员</span>
                          <span>通知方式</span>
                        </div>
                        <div class="notify-content">
                          <span>{{ items.notifyRole === 1 ? '所有人' :  items.notifyRole === 2 ? '个案管理师' : items.notifyRole === 3 ? '患者' : '' }}</span>
                          <span>{{ items.notifyType === 1 ? '全病程IM房间' :  items.notifyType === 2 ? '短信' : '' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="right-content">
          <butterfly-vue ref="butterfly" className="flowChartBox" :canvasData="logicData.mockData" key="flowChartBox" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ButterflyVue from "@/views/decisionPage/flowChart/butterfly-vue.vue";
import nodeType from "@/views/decisionPage/flowChart/node-type.vue";
import { getDecisionExecutedRecordDetail } from "../../api/crossApi";

export default {
  props: {
    titleType: {
      type: String,
      default: "headline" //大标题， subheading 小标题
    },
    titleName: {
      type: String,
      default: ""
    },
    logicList: {
      type: Object,
      default: () => {}
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      liConHeight: 0,
      openFlag: {},
      logicVisible: false,
      resultName: "结果1",
      logicData: {
        leftData: [],
        mockData: {}
      }
    };
  },
  components: {
    ButterflyVue
  },
  watch: {
    logicList: {
      handler(val) {
        this.setInitOpenFlag(val);
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.setInitOpenFlag(this.logicList);
  },
  methods: {
    // 设置初始值
    setInitOpenFlag(val) {
      for (let key in val) {
        this.$set(this.openFlag, [key], true);
      }
    },
    open(key) {
      const liCon = this.$refs[`liCon${key}`][0];
      var height = liCon.offsetHeight;
      if (height === this.liConHeight) {
        // 展开
        liCon.style.height = "auto";
        height = liCon.offsetHeight;
        liCon.style.height = this.liConHeight + "px";
        var f = document.body.offsetHeight; // 必加
        liCon.style.height = height + "px";
      } else {
        // 收缩
        liCon.style.height = height + "px";
        var f = document.body.offsetHeight;
        liCon.style.height = this.liConHeight + "px";
      }
      this.openFlag[key] = !this.openFlag[key];
    },
    // 点击逻辑生效数据
    async logicClick(id) {
      // 点击逻辑生效获取数据 logicData
      this.logicVisible = true;
      // 调用详情接口
      let { code, data } = await getDecisionExecutedRecordDetail(id);
      if (code === 0) {
        this.$set(
          this.logicData,
          "leftData",
          JSON.parse(data.executedResultJson)
        );
        let executedTreeJson, nodes;
        if (data.executedTreeJson) {
          executedTreeJson = JSON.parse(data.executedTreeJson);
          nodes = executedTreeJson.nodes.map(item => {
            return {
              ...item,
              render: nodeType
            };
          });
        }
        this.$set(this.logicData, "mockData", { ...executedTreeJson, nodes });
      }
    },
    openDialog() {
      setTimeout(() => {
        this.$refs.butterfly.setMinimap();
      }, 100);
    },
    closeDialog() {
      this.$refs.butterfly.stopMinmap();
    },
    // 转换编链类型
    translateItemType(type) {
      switch (type) {
        case 1:
          return "药物治疗";
          break;
        case 2:
          return "功能训练";
          break;
        case 3:
          return "随访计划";
          break;
        case 4:
          return "评估方案";
          break;
        case 5:
          return "复诊计划";
          break;
        case 6:
          return "日常提醒";
          break;
        case 7:
          return "疗程管理师任务";
          break;
        case 8:
          return "健康宣教";
          break;
        case 9:
          return "运动处方";
          break;
        case 10:
          return "重点指标";
          break;
      }
    },
    // 转换开始时间类型
    translateStartTimeType(type) {
      switch (type) {
        case 1:
          return "服务启动时间";
          break;
        case 3:
          return "入案时间";
          break;
        case 5:
          return "首次入院时间";
          break;
        case 6:
          return "首次手术时间";
          break;
        case 7:
          return "首次出院时间";
          break;
        case 8:
          return "线上随访时间";
          break;
        case 9:
          return "线下随访时间";
          break;
        case 10:
          return "服务结束时间";
          break;
        case 11:
          return "化疗时间";
          break;
        case 12:
          return "触发时间";
          break;
      }
    }
  }
};
</script>

<style lang="less">
.collapse {
  .el-dialog {
    width: 80%;
    .content {
      display: flex;
      .left-content {
        width: 500px;
      }
      .right-content {
        flex: 1;
        border: solid 1px #eee;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.collapse {
  .el-dialog {
    .left-content {
      .header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        margin-top: 3px;
        margin-right: 10px;
        p {
          width: 4px;
          height: 15px;
          background: #1a7bfc;
          margin-right: 12px;
        }
        h1 {
          font-size: 14px;
          font-weight: 500;
          color: rgba(0, 0, 0, 1);
          line-height: 22px;
        }
      }
      .data-content {
        padding: 10px 20px;
        // 编链
        .chaining {
          display: flex;
          color: rgba(0, 0, 0, 0.85);
          line-height: 2;
          .label {
            width: 120px;
          }
          .value {
            flex: 1;
          }
        }
        .text,
        .ques {
          margin-bottom: 15px;
          line-height: 1.5;
        }
        // .ques {}
        .notify {
          color: #333333;
          margin-bottom: 10px;
          .notify-title,
          .notify-content {
            display: flex;
            height: 42px;
            line-height: 42px;
            border-bottom: 1px solid #f0f0f0;
            span {
              display: block;
              width: 50%;
              text-align: center;
              &:first-child {
                border-right: 1px solid #f0f0f0;
              }
            }
          }
          .notify-title {
            background: #f0f0f0;
          }
        }
      }
    }
  }
}
.p_cont {
  font-size: 14px;
  color: #555;
  overflow: hidden;
  transition: height 0.5s;
  margin-top: 10px;
  color: #333333;
  background: #F8F8F8;
  border-radius: 6px;
  padding: 0 16px;
  .p_cont_list {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    cursor: pointer;
    border-bottom: 1px solid #EEEEEE;
    .text {
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:hover {
      background: #f2f7fe;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}

.message-item-box-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0 10px;
  margin-top: 10px;
  border-radius: 2px;
  &.active {
    color: #1a7bfc;
  }
  .message-item-box-name {
    font-size: 12px;
    // font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #1a7bfc;
    line-height: 17px;
  }

  .message-item-box-text {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .name-icon {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1a7bfc;
      line-height: 14px;
      margin: 0 5px 0 0;
    }

    .instructions_icon {
      width: 0px;
      height: 0px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 6px solid #1a7bfc;
    }

    .down_icon {
      transform: rotate(180deg);
      transition-delay: 0.35s;
      animation: mymove 1s;
    }
    .up_icon {
      transform: rotate(0deg);
      transition-delay: 0.35s;
      animation: mymove1 1s;
    }
    @keyframes mymove {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(180deg);
      }
    }

    @-webkit-keyframes mymove

                /*Safari and Chrome*/ {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(180deg);
      }
    }

    @keyframes mymove1 {
      from {
        transform: rotate(180deg);
      }

      to {
        transform: rotate(0deg);
      }
    }

    @-webkit-keyframes mymove1

                /*Safari and Chrome*/ {
      from {
        transform: rotate(180deg);
      }

      to {
        transform: rotate(0deg);
      }
    }
  }
}
.border_bottom {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 10px;
  transition: 0.2s ease-out;
}
.message-title-box {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  .name-icon {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 14px;
  }

  .instructions_icon {
    width: 0px;
    height: 0px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 6px solid #bfbfbf;
  }

  .down_icon {
    transform: rotate(180deg);
    transition-delay: 0.35s;
    animation: mymove 1s;
  }
  .up_icon {
    transform: rotate(0deg);
    transition-delay: 0.35s;
    animation: mymove1 1s;
  }
  @keyframes mymove {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(180deg);
    }
  }

  @-webkit-keyframes mymove

            /*Safari and Chrome*/ {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(180deg);
    }
  }
  @keyframes mymove1 {
    from {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(0deg);
    }
  }

  @-webkit-keyframes mymove1

                /*Safari and Chrome*/ {
    from {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(0deg);
    }
  }
}

/deep/.el-table__header-wrapper {
  background-color: #fafafa;
}
/deep/.el-table {
  border-left: none;
  border-right: none;
}
/deep/.el-table th > .cell {
  color: #333;
  font-weight: bold;
}
/deep/.el-table th {
  background: #f0f0f0;
}

/deep/.el-tabs__nav-wrap::after {
  background: #ffffff;
}

/deep/.el-table tr > td:first-child {
  border-right: 1px solid #ebeef5;
}
</style>